<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left">
              <el-col :span="12">
                <div style="font-color">导入提示：</div>
                <el-button @click="down"
                           style="margin-top:15px">下载上报申请模板</el-button>
                <div class="padding font-color">日期格式：2019-01-01</div>
                <div class="padding font-color">系统支持Excel（xlsx文件） 格式文件导入</div>
                <div class="padding font-color">Excel 最多支持导入 2000 行（含表头）。</div>
              </el-col>
              <el-col :span="12">
                <span style="color:red">请选择要导入的项目(必填)：</span>
                <el-select v-model="cat_id"
                           placeholder="请选择项目"
                           clearable>
                  <div v-for="item in projectList"
                       :key="item.year">
                    <el-option v-if="item.year"
                               :label="item.year"
                               :value="item.year"
                               :disabled="true"></el-option>
                    <el-option v-for="items in item.son"
                               :key="items.id"
                               :label="items.cat_name"
                               :value="items.id"></el-option>
                  </div>
                </el-select>
                <el-upload ref="upload"
                           class="upload-demo"
                           :action="exportsUrl"
                           :before-upload="beforeUpload"
                           :data="data"
                           multiple
                           :limit="1"
                           :on-success="handleSuccess"
                           :file-list="fileList"
                           :auto-upload="false">
                  <el-button size="medium"
                             type="primary"
                             style="margin-top:30px"
                             @click="clearFileList">选择文件</el-button>
                </el-upload>
                <el-button size="medium"
                           type="primary"
                           @click="exports"
                           style="margin-top:30px">开始导入</el-button>
              </el-col>
              <div style="margin:15px 124px 0 0;float:right"
                   v-if="exportResult">
                <span>导入结果</span>
                <div>
                  失败数据
                  <span style="color:red">{{failNum}}</span>条
                  <el-button size="mini"
                             type="primary"
                             v-if="failNum > 0"
                             @click="downFailLog"
                             style="margin-top:30px;margin-left:5px">下载错误日志</el-button>
                  <span style="color:red"
                        v-if="failNum > 0">请根据提示修改错误记录，确认无误后上传该文件</span>
                </div>
                <div style="margin-top:15px">
                  成功导入
                  <span style="color:green">{{succNum}}</span>条
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import "@/components/Hospital/public/poster.less";
import Axios from "axios";
import myHead from "@/components/Hospital/public/head";
import centerHead from "@/components/Hospital/public/center_head";
import leftMenu from "@/components/Hospital/public/menu";
import footDiv from "@/components/Hospital/public/foot";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv
  },
  data () {
    return {
      projectList: [],
      cat_id: "",
      fileList: [], // 文件列表
      data: {}, // 文件数据
      exportResult: false,
      failNum: 0,
      succNum: 0,
      errorLog: null, // 错误日志保存的文件数据
      exportsUrl: baseUrl + "report-importData"
    };
  },
  methods: {
    down () {
      let title = "上报申请.xlsx";
      let data = {};
      let unit = sessionStorage.getItem("unitAuth");
      if (unit) {
        unit = JSON.parse(unit);
        data["access-token"] = unit["access-token"];
      }

      return Axios.request({
        url: baseUrl + "report-getReportApplyTemplate",
        data,
        method: "post",
        responseType: "arraybuffer"
      }).then(res => {
        if (res.hasOwnProperty("code")) {
          var enc = new TextDecoder("utf-8");
          var result = JSON.parse(enc.decode(new Uint8Array(res)));
          if (result.code !== 200) {
            this.$Message.warning(result.msg);
          }
        } else {
          this.download(res, title);
        }
      });
    },
    download (data, name) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" }); // 将文件流放到blob对象里面
      let url = window.URL.createObjectURL(blob); // 创建url 地址为blob对象
      let alink = document.createElement("a");
      alink.href = url;
      alink.download = name; //文件名
      alink.click();
    },
    beforeUpload (file) {
      // 文件上传之前操作
      if (!file.name.includes(".xlsx")) {
        this.$message({
          showClose: true,
          message: "仅支持导入.xlsx的文件！",
          type: "warning"
        });
        return false;
      }
    },
    exports () {
      // 开始导入文件
      if (this.cat_id == "") {
        this.$message({
          showClose: true,
          message: "请先选择项目",
          type: "error"
        });
        return;
      }
      let unit = sessionStorage.getItem("unitAuth");
      unit = JSON.parse(unit);
      this.data["access-token"] = unit["access-token"];
      this.data.cat_id = this.cat_id;
      this.$refs.upload.submit();
    },
    handleSuccess (res, file, fileList) {
      if (res.code == 200) {
        this.exportResult = true;
        this.failNum = res.data.fail;
        this.succNum = res.data.success;
        if (res.data.fail > 0) {
          this.errorLog = this.dataURLtoFile(res.data.file, "错误日志.xlsx"); // 存储错误日志
        }
      } else if (res.code == -1) {
        this.$message.error(res.msg);
      }
    },
    downFailLog () {
      // 下载错误日志
      this.download(this.errorLog, "错误日志.xlsx");
    },
    clearFileList () {
      this.fileList = []; // 导入之前清空之前的文件列表
    },
    dataURLtoFile (dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1], // 拿到文件的类型
        bstr = atob(arr[1]), // atob方法将base64字符串转换为binary文件流数据
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n); // 将文件流转换成Unicode编码 返回值是0 - 65535之间的整数。
      }
      return new File([u8arr], filename, { type: mime }); // 第一个参数是转换好的Unicode编码
    }
  },
  created () {
    this.$db.post("report-getReportCategoryArray", {}).then(res => {
      // 项目下拉菜单
      this.projectList = res.data;
    });
  }
};
</script>
<style lang="less" scoped>
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    // max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 1vw;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
  .center-footer {
    width: 100%;
    background-color: #9b0204;
    margin-top: 60px;
    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 22px 0;

      > span {
        font-size: 14px;
        color: #cb5c5e;
      }
    }
  }
  .padding {
    padding: 8px 0;
  }
  .font-color {
    color: #606266;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/Report/export.vue